import type { MessageChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ShopperAiIntegrationType } from "@redotech/effect-api-shared/models/shopper-ai/integration/integration";
import PostscriptLogoIcon from "@redotech/redo-icons/postscript-favicon.svg";
import StickerSquareIcon from "@redotech/redo-icons/sticker-square.svg";
import TiktokIcon from "@redotech/redo-icons/tiktok-color-icon.svg";
import AttentiveLogoIcon from "@redotech/redo-web/icon-old/attentive-logo.svg";
import ChatBubbleIcon from "@redotech/redo-web/icon-old/chat-bubble.svg";
import FacebookIcon from "@redotech/redo-web/icon-old/facebook-color.svg";
import InstagramIcon from "@redotech/redo-web/icon-old/instagram-color.svg";
import MailIcon from "@redotech/redo-web/icon-old/mail.svg";
import PhoneIcon from "@redotech/redo-web/icon-old/phone-01.svg";
import SmsIcon from "@redotech/redo-web/icon-old/send-sms.svg";
import type { ComponentType, SVGProps } from "react";

/**
 * Human-readable labels for message channels.
 */
export const MessageChannelReadable: Record<MessageChannel, string> = {
  gmail: "Email",
  outlook: "Email",
  redoChat: "Chat",
  facebook: "Facebook Messenger",
  facebookComments: "Facebook Comments",
  instagram: "Instagram Direct",
  instagramComments: "Instagram Comments",
  sms: "SMS",
  voice: "Voice Call",
  attentive: "Attentive",
  postscript: "Postscript",
  tiktok: "TikTok",
  contactForm: "Contact Form",
  internalNote: "Internal Note",
  mobileMessage: "iMessage",
};

/**
 * Icon components for each message channel.
 */
export const MessageChannelIcons: Record<
  MessageChannel,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  gmail: MailIcon,
  outlook: MailIcon,
  redoChat: ChatBubbleIcon,
  facebook: FacebookIcon,
  facebookComments: FacebookIcon,
  instagram: InstagramIcon,
  instagramComments: InstagramIcon,
  sms: SmsIcon,
  voice: PhoneIcon,
  attentive: AttentiveLogoIcon,
  postscript: PostscriptLogoIcon,
  tiktok: TiktokIcon,
  contactForm: MailIcon,
  internalNote: StickerSquareIcon,
  mobileMessage: ChatBubbleIcon,
};

/**
 * Human-readable labels for integration types.
 */
export const IntegrationTypeReadable: Record<ShopperAiIntegrationType, string> =
  {
    gmail: "Email",
    outlook: "Email",
    instagram: "Instagram",
    facebook: "Facebook",
    tiktok: "TikTok",
    attentive: "Attentive",
    postscript: "Postscript",
    redoChatAi: "Redo Chat AI",
    redoChatFlow: "Redo Chat Flow",
    redoChatLive: "Redo Chat Live",
  };

/**
 * Icon components for each integration type.
 */
export const IntegrationTypeIcons: Record<
  ShopperAiIntegrationType,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  gmail: MailIcon,
  outlook: MailIcon,
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  tiktok: TiktokIcon,
  attentive: AttentiveLogoIcon,
  postscript: PostscriptLogoIcon,
  redoChatAi: ChatBubbleIcon,
  redoChatFlow: ChatBubbleIcon,
  redoChatLive: ChatBubbleIcon,
};
